import { render, staticRenderFns } from "./AppAsideBar.vue?vue&type=template&id=360f6d90&scoped=true"
import script from "./AppAsideBar.vue?vue&type=script&lang=js"
export * from "./AppAsideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360f6d90",
  null
  
)

export default component.exports